import { render, staticRenderFns } from "./followersCount.vue?vue&type=template&id=4b2ee0b6&"
import script from "./followersCount.vue?vue&type=script&lang=js&"
export * from "./followersCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports